module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens1-e1f7b0027cf4da6cd70bda407c995230.jpg";